import { createContext } from 'react';
import { defaultAlertModalState, ModalProps } from './constants';

type TModalContext = {
  modalDetails: ModalProps;
  setModalDetails: React.Dispatch<React.SetStateAction<ModalProps>>;
};
type TBackdropLoadingContext = {
  showBackdropLoading: React.Dispatch<React.SetStateAction<boolean>>;
  showBackdropDescription: React.Dispatch<React.SetStateAction<string>>;
};
export const ModalContext = createContext<TModalContext>({
  modalDetails: defaultAlertModalState,
  setModalDetails: () => {},
});
export const BackdropLoadingContext = createContext<TBackdropLoadingContext>({
  showBackdropLoading: () => {},
  showBackdropDescription: () => {},
});
